module.exports = __webpack_public_path__ + "static/media/pizza2.f6294ce2.jpg";